import { render, staticRenderFns } from "./OrganizationSpecialistTable.vue?vue&type=template&id=13f745ec&scoped=true&"
import script from "./OrganizationSpecialistTable.vue?vue&type=script&lang=js&"
export * from "./OrganizationSpecialistTable.vue?vue&type=script&lang=js&"
import style0 from "./OrganizationSpecialistTable.vue?vue&type=style&index=0&id=13f745ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f745ec",
  null
  
)

export default component.exports